export default __webpack_public_path__ + "static/Specyfikacja_Edenred_PICTURE_CARDS.pdf";